import { Platform } from '@angular/cdk/platform';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Device } from '@capacitor/device';
import { AuthService } from '../core/services/auth.service';
import { EventService } from '../core/services/event.service';
import { Location } from '@angular/common';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-admin-menu',
  templateUrl: './admin-menu.component.html',
  styleUrls: ['./admin-menu.component.css']
})
export class AdminMenuComponent implements OnInit {
  photoWallAccess: any;
  publicAccess: any;
  readonly featureSettingsEnabled: boolean = environment.features.featureSettings;

  constructor(private eventService: EventService,
    public dialog: MatDialog,
    private location: Location,
    private authService: AuthService,
    private router: Router,
    private platform: Platform) { }

  async ngOnInit() {
    localStorage.removeItem('eventId');
    localStorage.removeItem('viewer_hash');
    localStorage.removeItem('eventData');
    localStorage.removeItem('inviteData');
    try {
      (await (this.eventService.getMyAccountDetails())).subscribe({
        next: (resp: any) => {
          // console.log({ resp }); //__CONSOLE_LOG__ //__CONSOLE_LOG__
          if (resp) {
            this.photoWallAccess = resp.account.photowall;
            this.publicAccess = resp.account.public_access;
          }
        },
        error: (err: any) => {
          // console.error(err); //__CONSOLE_LOG__ //__CONSOLE_LOG__
        },
      });
    } catch (err: any) {
      // console.error(err);
    }
  }


  logout() {
    this.authService
      .signOut()
      .then((res) => {
        this.router.navigateByUrl(
          "/auth/login"
        );
      })
      .catch((err) => {
        // console.error(err); //__CONSOLE_LOG__
      });
  }

  goBack() {
    // localStorage.removeItem('eventId');
    this.router.navigateByUrl('/home');
  }

  eventSettings(hex: any) {
    localStorage.setItem('eventId', hex);
    this.router.navigateByUrl('/event-settings');
  }

  async downloadApp() {
    const info = await Device.getInfo();

    if (this.platform.IOS && info.model === 'iPhone' && info.platform === 'web') {
      window.location.href = 'https://apps.apple.com/in/app/picaggo/id1527686260';
    }

    if (this.platform.ANDROID && info.platform === 'web') {
      window.location.href = 'https://play.google.com/store/apps/details?id=application.share.photo.picaggo';
    }

    if (!this.platform.ANDROID && !this.platform.IOS && info.platform === 'web') {
      window.location.href = 'https://picaggo.com';
    }
  }

}
